import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Line } from 'react-chartjs-2'

import DualRing from './DualRing'
import Error from './Error'

import { loadDashboard } from '../actions/Dashboard'

const chartOptions = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true
        }
      }
    ],
    xAxes: [
      {
        ticks: {
          display: false
        }
      }
    ]
  },
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    onClick: (e) => e.stopPropagation()
  }
}

class Dashboard extends Component {
  componentWillMount() {
    if (this.props.dashboard.charts === null) {
      this.reloadDashboard()
    }
  }
  reloadDashboard() {
    this.props.loadDashboard()
  }
  render() {
    const { charts, error, loading } = this.props.dashboard
    return (
      <div>
        <div className='page-header'>
          <div className='ph-title'>Dashboard</div>
          <div className='ph-descr txt'>
            Statistiche presenze per i tuoi corsi
          </div>
          <ul className='ph-btn'>
            <li>
              <button
                onClick={() => this.reloadDashboard()}
                className='lnk-tools'
              >
                <i className='fas fa-redo-alt'></i> ricarica
              </button>
            </li>
          </ul>
          {/* <div className="ph-count">
            {
              list !== null && (
                list.length + ((list.length === 1) ? ' risultato' : ' risultati')
              )
            }
            {
              list === null && (
                <i className="fas fa-sync fa-spin"></i>
              )
            }
          </div> */}
        </div>
        {loading && <DualRing />}
        {error && <Error error={error} />}
        <ul className='con-chart'>
          {charts !== null &&
            charts.map((s, index) => {
              return (
                <li key={index}>
                  <Line data={s} width={100} options={chartOptions} />
                </li>
              )
            })}
        </ul>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, { loadDashboard })(Dashboard)



// WEBPACK FOOTER //
// ./src/components/Dashboard.js